import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mediaQueries } from 'styles/utils/mediaQueries';

const propTypes = {
  src: PropTypes.string.isRequired,
};

const Thumbnail = ({ src }) => <Wrap src={src} />;

Thumbnail.propTypes = propTypes;

export default Thumbnail;

const Wrap = styled.div`
  width: 90px;
  background-image: ${({ src }) => `url(${src})`};
  background-size: cover;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
    height: 150px;

    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  `}
`;
